import { IMicrofrontendsAPI } from 'shared/types/microfrontends';

import { openAuthModal } from '../../repositories/header-frontend/v3/open-auth-modal';
import { updateHeader } from '../../repositories/header-frontend/v3/update-header';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    header: {
      openAuthModal,
      updateHeader,
    },
  };
}
